// extracted by mini-css-extract-plugin
export default {"container":"SearchBox_container__ime5J","container__input":"SearchBox_container__input__wahvD","container__icon":"SearchBox_container__icon__V8py0"};